import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

unregister();

ReactDOM.render(<App />, document.getElementsByClassName('dermalogica-sound-sleep-cocoon')[0]);
//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js